


import { useLoader } from '../../../../../context/LoaderContext';



import { Modal, Table, InputNumber, Tooltip, Button, Switch, Form, message, notification } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { addNotesApprenants } from '../../../../../api/geoprod';
import { useNavigate } from 'react-router-dom';


const ModalSaisieNotes = ({ openModal, setOpenModal, listeApprenants, listeModules, rattrapage,id_affaire }) => {
  const { t } = useTranslation();
  const { setIsLoading } = useLoader();
  const [notes, setNotes] = useState({});
  const [rattrapageEnabled, setRattrapageEnabled] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const handleNoteChange = (apprenantId, moduleKey, type, value) => {
    const key = `${apprenantId}-${moduleKey}-${type}`;
    setNotes((prev) => ({ ...prev, [key]: value }));
  };

 
  
  const handleRattrapageSwitch = (apprenantId, moduleKey, checked) => {
    const key = `${apprenantId}-${moduleKey}`;
    setRattrapageEnabled((prev) => ({ ...prev, [key]: checked }));

    if (!checked) {
      const noteKey = `${apprenantId}-${moduleKey}-rattrapage`;
      setNotes((prev) => {
        const newNotes = { ...prev };
        delete newNotes[noteKey];
        return newNotes;
      });
      form.setFieldValue(noteKey, undefined);
    }
  };

  const moduleSubColumns = listeModules?.examen?.map((mod) => {
    const children = [
      {
        title: "Examen",
        dataIndex: `examen-${mod.module_key}`,
        key: `examen-${mod.module_key}`,
        width: 120,
        render: (_, record) => {
          const fieldName = `${record.id}-${mod.module_key}-examen`;
          return (
            <Form.Item
              name={fieldName}
              rules={[{ required: true, message: "" }]}
              style={{ marginBottom: 0 }}
            >
              <InputNumber
              size="small"
                min={0}
                max={20}
                onChange={(value) => handleNoteChange(record.id, mod.module_key, "examen", value)}
              />
            </Form.Item>
          );
        },
      },
    ];

    if (rattrapage) {
      children.push({
        title: "Rattrapage",
        dataIndex: `rattrapage-${mod.module_key}`,
        key: `rattrapage-${mod.module_key}`,
        width: 180,
        render: (_, record) => {
          const switchKey = `${record.id}-${mod.module_key}`;
          const isEnabled = rattrapageEnabled[switchKey] ?? false;
          const fieldName = `${record.id}-${mod.module_key}-rattrapage`;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Switch
                checked={isEnabled}
                onChange={(checked) =>
                  handleRattrapageSwitch(record.id, mod.module_key, checked)
                }
                size="small"
              />
              <Form.Item
                name={fieldName}
                rules={isEnabled ? [{ required: true, message: "" }] : []}
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                //   style={{ width: 60 , height:40}}
               size="small"
                  max={20}
                  disabled={!isEnabled}
                  onChange={(value) =>
                    handleNoteChange(record.id, mod.module_key, "rattrapage", value)
                  }
                />
              </Form.Item>
            </div>
          );
        },
      });
    }

    return {
      title: <Tooltip title={mod.name_module}>{mod.module_key}</Tooltip>,
      children,
    };
  });
const getFullName = (record) => {
  const isArabic = localStorage.getItem("language") === "ar" && record?.name_ar;
  const parts = isArabic
    ? [record.name_ar, record.surname_ar]
    : [record.name, record.surname];
  return parts.filter(Boolean).join(" ");
};
  const columns = [

    
    {
      title: t("Apprenant"),
      dataIndex: "apprenant",
      key: "apprenant",
    //   width: 220,
   render: (_, record) => getFullName(record)
    },
    //   {
    //   title: t("Apprenant"),
    //   dataIndex: "apprenant",
    //   key: "apprenant",
    // //   width: 220,
    //   render: (_, record) => `${record.name}  ${record?.name_ar}` ,
    // },
    {
      title: "Liste des modules",
      children: moduleSubColumns,
    },
  ];

  const dataSource = listeApprenants.map((a) => ({
    key: a.id,
    id: a.id,
    name: a.name,
    name_ar: a.name_ar,
  }));

  const handleSubmit = async () => {
    try {
        
      const values = await form.validateFields()
      setIsLoading(true)
      console.log("listeModules",listeModules)
       const examModulesMap = Object.fromEntries(
      (listeModules?.examen || []).map(m => [m?.module_key, m?.id_examen_module])
    );
    const rattrapageModulesMap = Object.fromEntries(
      (listeModules?.rattrapage || []).map(m => [m?.module_key, m?.id_examen_module])
    );

    const payloadNotes = [];

    Object.entries(notes)?.forEach(([key, note]) => {
      const [id_apprenant, module_key, type] = key?.split("-");
      const id_examen =
        type === "examen" ? examModulesMap[module_key] : rattrapageModulesMap[module_key];

    //   if (id_examen !== undefined) {
              if (id_examen) {
        payloadNotes.push({
          id_apprenant: Number(id_apprenant),
          id_examen: id_examen?.toString() ,
          note,
        });
      }
    });
    //  debugger
addNotesApprenants({"apprenants" : payloadNotes})
.then((responseAddNotes) => {
             notification?.success({
                  message: t("Erreur"),
                  description:  t(responseAddNotes?.data?.message),
                  duration: 0,
                });
      setOpenModal(false);
           navigate(
                                "/apprenants/notes",
                                 {
                                state: {
                                  id_affaire:id_affaire,
                                },
                              }
                            
                              );
      setIsLoading(false)
    })
    .catch((error)=>{
       notification?.error({
                  message: t("Erreur"),
                  description:  t(error?.data?.message),
                  duration: 0,
                });
      setIsLoading(false)
      
    })

    } catch (err) {
      message.error("Veuillez remplir les champs obligatoires");
    }
  };

  return (
    <Modal
      title={t("Saisie des notes")}
      open={openModal}
      width={rattrapage ? 800 : 500}
      onCancel={() => setOpenModal(false)}

      footer={[
        <Button key="cancel" onClick={() => setOpenModal(false)}>
          Annuler
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Valider
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Table
          className="compact-table"
          columns={columns}
          dataSource={dataSource}
          bordered
          size="small"
          pagination={false}
          scroll={{ x: "100%" }}
        />
      </Form>
    </Modal>
  );
};

export default ModalSaisieNotes;
